<h2 mat-dialog-title>{{header}}</h2>
<mat-dialog-content>{{content}}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>